// @flow

/**
 * Flex box
 * Usage: ...flex('space-between', 'flex-end')
 */
export function flex (justifyContent: string, alignItems: string): Object {
  return {
    display: 'flex',
    justifyContent: justifyContent || 'center',
    alignItems: alignItems || 'center',
  }
}

export function flexColumn (justifyContent: string, alignItems: string): Object {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: justifyContent || 'center',
    alignItems: alignItems || 'center',
  }
}

export function flexWrap (justifyContent: string, alignItems: string): Object {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: justifyContent || 'center',
    alignItems: alignItems || 'center',
  }
}

export default {
  flex,
  flexColumn,
  flexWrap,
}
